import { render, staticRenderFns } from "./RaceBookmakers.vue?vue&type=template&id=4c16c720&scoped=true"
import script from "./RaceBookmakers.vue?vue&type=script&lang=js"
export * from "./RaceBookmakers.vue?vue&type=script&lang=js"
import style0 from "./RaceBookmakers.vue?vue&type=style&index=0&id=4c16c720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16c720",
  null
  
)

export default component.exports